import React from "react";
import { CitationData } from "./CitationsResults.hook";
import { useTheme } from "../../../../Styles/ThemeHook";
import "./CitationCard.less";

interface CitationCardProps {
    citation: CitationData;
    variant?: "default" | "guide";
}

export const CitationCard: React.FC<CitationCardProps> = ({
    citation,
    variant = "default",
}) => {
    const { theme } = useTheme();

    if (!citation?.html_description) {
        return null;
    }

    return (
        <div
            className={`citation-card citation-card--${variant}`}
            style={
                {
                    "--citation-title-color": theme.colors.primaryColor,
                } as React.CSSProperties
            }
        >
            <div
                className="citation-card__content"
                dangerouslySetInnerHTML={{ __html: citation.html_description }}
            />
        </div>
    );
};
